import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/image/newhome/video-static.png'
import _imports_1 from '../../../assets/image/newhome/play.png'
import _imports_2 from '../../../assets/image/newhome/goleft.png'
import _imports_3 from '../../../assets/image/newhome/left.png'
import _imports_4 from '../../../assets/image/newhome/right.png'


const _withScopeId = n => (_pushScopeId("data-v-83dbfad8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "video-static" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "static-img",
    src: _imports_0
  })
], -1))
const _hoisted_3 = { class: "video-container" }
const _hoisted_4 = {
  class: "video-list",
  ref: "videoListRef"
}
const _hoisted_5 = ["poster", "onMouseover"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["onMouseout", "onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3VideoPlay = _resolveComponent("vue3VideoPlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos.datas, (video, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "box"
          }, [
            _createElementVNode("video", {
              ref_for: true,
              ref: "videoPlayer",
              poster: video.pic,
              class: "video-item",
              onMouseover: ($event: any) => (_ctx.showOver(index))
            }, [
              _createElementVNode("source", {
                src: video.video,
                type: "img"
              }, null, 8, _hoisted_6)
            ], 40, _hoisted_5),
            (video.isMouseOver)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "overlay",
                  onMouseout: ($event: any) => (_ctx.showOut(index)),
                  onClick: ($event: any) => (_ctx.handleVideoClick(index))
                }, _hoisted_9, 40, _hoisted_7))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ], 512),
      _createElementVNode("div", {
        ref: "sonRef",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleOutsideClick && _ctx.handleOutsideClick(...args)))
      }, [
        (_ctx.isModalVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("i", {
                class: "icon-font icon-shanchu",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleModalVideoClick && _ctx.handleModalVideoClick(...args)))
              }),
              (_openBlock(), _createBlock(_component_vue3VideoPlay, _mergeProps({
                key: _ctx.options.src,
                ref: "videoPlayer",
                class: "video-modal"
              }, _ctx.options, {
                poster: _ctx.videos.datas[_ctx.selectedVideoIndex].pic2,
                src: _ctx.videos.datas[_ctx.selectedVideoIndex].video
              }), null, 16, ["poster", "src"]))
            ]))
          : _createCommentVNode("", true)
      ], 512)
    ]),
    (!_ctx.showleft)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _imports_2,
          alt: "",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.scrollLeft && _ctx.scrollLeft(...args))),
          class: "left-button"
        }))
      : _createCommentVNode("", true),
    (_ctx.showleft)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: _imports_3,
          alt: "",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.scrollLeft && _ctx.scrollLeft(...args))),
          class: "left-button"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("img", {
      src: _imports_4,
      alt: "",
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.scrollRight && _ctx.scrollRight(...args))),
      class: "right-button"
    })
  ]))
}